<script>
import moment from 'moment'
import numeral from 'numeral'

export default {
  functional: true,

  props: {
    ticketNo: {
      type: String,
      default: ''
    },

    date: {
      type: Date,
      default: null
    },

    dueDate: {
      type: Date,
      default: null
    },

    interest: {
      type: Number,
      default: 0
    },

    interestPerMonth: {
      type: Number,
      default: 0
    }
  },

  render(h, { data, props }) {
    const Item = ({ props, slots }) => (
      <el-row
        type="flex"
        gutter={16}
        style={{ marginBottom: '0.5rem', fontSize: '1rem' }}
      >
        <el-col span={null} style={{ width: '9rem', textAlign: 'right' }}>
          {props.label}
        </el-col>
        <el-col span={null} style={{ flex: '1', fontWeight: 'bold' }}>
          {slots().default}
        </el-col>
      </el-row>
    )

    return (
      <div {...data}>
        <Item label="เลขที่ตั๋วขายฝาก:">{props.ticketNo}</Item>
        <Item label="วันที่รับขายฝาก:">
          {moment(props.date).format('D MMMM Y')}
        </Item>
        <Item label="วันที่ครบกำหนด:">
          {moment(props.dueDate).format('D MMMM Y')}
        </Item>
        <Item label="อัตราดอกเบี้ย:">{props.interest * 100} %</Item>
        <Item label="ดอกเบี้ย/เดือน:">
          {numeral(props.interestPerMonth).format('0,0.00')} บาท
        </Item>
      </div>
    )
  }
}
</script>
